"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NotificationIcon = function NotificationIcon(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 17 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 20 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Notification' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Notification' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 17 20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-1",
    points: "0 0 16.9997385 0 16.9997385 19.9994667 0 19.9994667"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-1141.000000, -24.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Notification",
    transform: "translate(1141.000000, 24.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.0382,16.0194667 L1.96127692,16.0194667 C1.60166154,16.0194667 1.30743077,15.7221333 1.30743077,15.3568 C1.30743077,14.9821333 1.61212308,14.6541333 1.96127692,14.6541333 L3.92281538,14.6541333 L3.92281538,7.87813333 C3.92281538,5.31413333 5.97589231,3.22746667 8.49973846,3.22746667 C11.0235846,3.22746667 13.0766615,5.31413333 13.0766615,7.9488 L13.0766615,14.6941333 L15.0382,14.6941333 C15.3978154,14.6941333 15.6920462,14.9914667 15.6920462,15.3568 C15.6920462,15.7221333 15.3978154,16.0194667 15.0382,16.0194667 M8.49973846,18.6661333 C7.65496923,18.6661333 6.93835385,18.1168 6.66373846,17.3528 L10.3357385,17.3528 C10.0611231,18.1168 9.34581538,18.6661333 8.49973846,18.6661333 M8.49973846,1.3328 C8.98227692,1.3328 9.38766154,1.6128 9.6152,2.0088 C9.25296923,1.9368 8.88158462,1.89413333 8.49973846,1.89413333 C8.11789231,1.89413333 7.74781538,1.9368 7.38558462,2.0088 C7.61181538,1.6128 8.0172,1.3328 8.49973846,1.3328 M15.0382,13.3608 L14.3843538,13.3608 L14.3843538,7.87813333 C14.3843538,5.53413333 13.0400462,3.51946667 11.1033538,2.53946667 C11.0379692,1.1288 9.90027692,-0.000533333333 8.49973846,-0.000533333333 C7.09789231,-0.000533333333 5.9602,1.13013333 5.89612308,2.5408 C3.96073846,3.52613333 2.61512308,5.55413333 2.61512308,7.9488 L2.61512308,13.3208 L1.96127692,13.3208 C0.879815385,13.3208 -0.000261538462,14.2341333 -0.000261538462,15.3568 C-0.000261538462,16.4568 0.879815385,17.3528 1.96127692,17.3528 L5.29981538,17.3528 C5.60843077,18.8621333 6.92658462,19.9994667 8.49973846,19.9994667 C10.0742,19.9994667 11.3910462,18.8621333 11.6996615,17.3528 L15.0382,17.3528 C16.1196615,17.3528 16.9997385,16.4568 16.9997385,15.3568 C16.9997385,14.2568 16.1196615,13.3608 15.0382,13.3608",
    id: "Fill-1",
    fill: color,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.04285385,8.57093333 C5.02454615,8.5096 5.00754615,8.4176 5.00754615,8.3536 C5.00754615,6.6216 5.67316154,5.41493333 6.83700769,5.04293333 C7.17962308,4.93226667 7.54839231,5.1296 7.65562308,5.48026667 C7.76416154,5.83093333 7.57323846,6.2056 7.22800769,6.31626667 C6.38062308,6.58693333 6.31523846,7.94426667 6.31523846,8.3536 C6.31523846,8.3536 6.26423846,9.07493333 5.66923846,9.07493333 C5.07423846,9.07493333 5.04285385,8.57093333 5.04285385,8.57093333",
    id: "Fill-4",
    fill: color
  })))));
};
NotificationIcon.propTypes = _index.iconProps;
var _default = NotificationIcon;
exports["default"] = _default;